import CostsTable from './CostsTable'

export default CostsTable
